import {
  FETCH_CITIES,
  FETCH_CITIES_SUCCESS,
  FETCH_CITIES_FAILED,
  FETCH_SUBURBS,
  FETCH_SUBURBS_SUCCESS,
  FETCH_SUBURBS_FAILED,
  FETCH_WEBSITE_AREAS_START,
  FETCH_WEBSITE_AREAS_SUCCESS,
  FETCH_WEBSITE_AREAS_FAILED,

  FETCH_PP_CITIES_FAILED,
  FETCH_PP_CITIES_SUCCESS,
  FETCH_PP_CITIES,
  FETCH_PP_SUBURBS_SUCCESS,
  FETCH_PP_SUBURBS_FAILED,
  FETCH_PP_SUBURBS
} from "../store/types";

import { XMLParser } from "fast-xml-parser";


import {
  cloud_function_server_url,
} from "config";

export const fetchCities = (provinceId) => (dispatch) => {
  dispatch({
    type: FETCH_CITIES,
    payload: null
  });
  try {
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };

    fetch(
      `${cloud_function_server_url}/fetchCitiesByProvince?provinceId=${provinceId}`,
      requestOptions
    )
      .then((response) => {
        response;
        return response.json();
      })
      .then((result) => {
        dispatch({
          type: FETCH_CITIES_SUCCESS,
          payload: result
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_CITIES_FAILED, payload: error.message });
        console.error(error);
      });
  } catch (error) {
    dispatch({ type: FETCH_CITIES_FAILED, payload: error.message });
  }
};



export const fetchPPCities = (ProvinceID, token) => (dispatch) => {
  dispatch({
    type: FETCH_PP_CITIES,
    payload: null
  });
  try {
    const parser = new XMLParser();


    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "text/xml");


    const raw = `
   <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">
    <soapenv:Header/>
    <soapenv:Body>
        <tem:GetCities>
             <tem:Token>
                        <tem:Digest>${token.Digest}</tem:Digest>
                        <tem:UserName>${token.UserName}</tem:UserName>
                        <tem:StampTime>${token.StampTime}</tem:StampTime>
                        <tem:Expires>${token.Expires}</tem:Expires>
                        <tem:UID>${token.UID}</tem:UID>
              </tem:Token>
            <tem:ProvinceID>${ProvinceID}</tem:ProvinceID>
        </tem:GetCities>
    </soapenv:Body>
</soapenv:Envelope>   
   `;

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${cloud_function_server_url}/publishtoPrivateprop`, requestOptions)
      .then((response) => {
        return response.text();
      })
      .then((result) => {
        if (result.errors || result.error) {
          let errorMessage = ``;

          if (result.errors) {
            errorMessage = parseApiErrors(result.errors);
          }

          if (result.error) {
            errorMessage = result.error;
          }


          console.log(`Sorry an error has occured ,\n ${errorMessage}`)

          return;
        }


        const jsonObj = parser.parse(result);

        dispatch({
          type: FETCH_PP_CITIES_SUCCESS,
          payload: jsonObj['soap:Envelope']['soap:Body']['GetCitiesResponse']['GetCitiesResult']['CityModel']
        });

      })
      .catch((error) => {
        console.error(error);
        dispatch({
          type: FETCH_PP_CITIES_FAILED,
          payload: error
        });
      });
  } catch (error) {
    console.log('error', error);
    dispatch({ type: FETCH_PP_CITIES_FAILED, payload: error.message });
  }
};


export const fetchPPSuburbs = (SuburbID, token) => (dispatch) => {
  dispatch({
    type: FETCH_PP_SUBURBS,
    payload: null
  });
  try {
    const parser = new XMLParser();


    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "text/xml");


    const raw = `
   <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">
    <soapenv:Header/>
    <soapenv:Body>
     <tem:GetSuburbs>
             <tem:Token>
                        <tem:Digest>${token.Digest}</tem:Digest>
                        <tem:UserName>${token.UserName}</tem:UserName>
                        <tem:StampTime>${token.StampTime}</tem:StampTime>
                        <tem:Expires>${token.Expires}</tem:Expires>
                        <tem:UID>${token.UID}</tem:UID>
              </tem:Token>
            <tem:CityID>${SuburbID}</tem:CityID>
      </tem:GetSuburbs>
    </soapenv:Body>
</soapenv:Envelope>   
   `;

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${cloud_function_server_url}/publishtoPrivateprop`, requestOptions)
      .then((response) => {
        return response.text();
      })
      .then((result) => {
        console.log("suburbs", result);

        if (result.errors || result.error) {
          let errorMessage = ``;

          if (result.errors) {
            errorMessage = parseApiErrors(result.errors);
          }

          if (result.error) {
            errorMessage = result.error;
          }


          console.log(`Sorry an error has occured ,\n ${errorMessage}`)

          return;
        }


        const jsonObj = parser.parse(result);

        dispatch({
          type: FETCH_PP_SUBURBS_SUCCESS,
          payload: jsonObj['soap:Envelope']['soap:Body']['GetSuburbsResponse']['GetSuburbsResult']['SuburbModel']
        });
        console.log('suburbs', jsonObj['soap:Envelope']['soap:Body']['GetSuburbsResponse']['GetSuburbsResult']['SuburbModel']);

      })
      .catch((error) => {
        console.error(error);
        dispatch({
          type: FETCH_PP_SUBURBS_FAILED,
          payload: error
        });
      });
  } catch (error) {
    console.log('error', error);
    dispatch({ type: FETCH_PP_SUBURBS_FAILED, payload: error.message });
  }
};

export const fetchSuburbs = (cityId) => (dispatch) => {
  dispatch({
    type: FETCH_SUBURBS,
    payload: null
  });
  try {
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };

    fetch(
      `${cloud_function_server_url}/fetchSuburbsByCity?cityId=${cityId}`,
      requestOptions
    )
      .then((response) => {
        response;
        return response.json();
      })
      .then((result) => {
        dispatch({
          type: FETCH_SUBURBS_SUCCESS,
          payload: result
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_SUBURBS_FAILED, payload: error.message });
        console.error(error);
      });
  } catch (error) {
    dispatch({ type: FETCH_SUBURBS_FAILED, payload: error.message });
  }
};

export const fetchWebsiteAreas = () => (dispatch) => {
  dispatch({
    type: FETCH_WEBSITE_AREAS_START,
    payload: null
  });
  try {
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };

    fetch(
      //returns dummy data in the current use case
      `${cloud_function_server_url}/fetchWebsiteAreas`,
      requestOptions
    )
      .then((response) => {
        response;
        return response.json();
      })
      .then((result) => {
        dispatch({
          type: FETCH_WEBSITE_AREAS_SUCCESS,
          payload: result
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_WEBSITE_AREAS_FAILED, payload: error.message });
        console.error(error);
      });
  } catch (error) {
    dispatch({ type: FETCH_WEBSITE_AREAS_FAILED, payload: error.message });
  }
};
